// NotAuthorized.tsx
import React from 'react';
import LazyMapControl from '../components/map/LazyMapControl';
const MapPage = () => {
    return (React.createElement(LazyMapControl, null));
};
export default MapPage;
